import $ from 'jquery'
import '../lib/rails' // to enable CSRF on $.ajax
import * as t from 'io-ts'
import { isLeft } from 'fp-ts/Either'
import { PathReporter } from 'io-ts/PathReporter'
import { extractMessageFromAjaxFailure } from './ajax-error'

const debug = require('debug')('pm:ajax')

export function jsonRequest<T>(
  decoder: t.Decoder<T, T>,
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  url: string,
  data?: any
): Promise<T> {
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      data,
      dataType: 'json',
      method,
    })
      .done(data => {
        const decoded = decoder.decode(data)
        if (isLeft(decoded)) {
          const messages = PathReporter.report(decoded)
          debug('error while decoding', messages)
          reject(new Error(messages.join('\n')))
        } else {
          resolve(decoded.right)
        }
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        debug(`${method} ${url} failed`, { textStatus, errorThrown, jqXHR })

        const message = extractMessageFromAjaxFailure(
          jqXHR,
          errorThrown || textStatus
        )

        debug('jsonRequest failed', message)
        reject(new Error(message))
      })
  })
}
